import { format, formatDistanceToNowStrict } from 'date-fns';

export function formatDate(iso: string | undefined | null, pattern = 'PP'): string {
  if (!iso) return '';
  try {
    return format(new Date(iso), pattern);
  } catch {
    return iso;
  }
}

export function formatRelative(iso: string | undefined | null): string {
  if (!iso) return '';
  try {
    return formatDistanceToNowStrict(new Date(iso), { addSuffix: true });
  } catch {
    return iso;
  }
}

export function formatPercent(n: number, digits = 0): string {
  if (Number.isNaN(n)) return '—';
  return `${(n * 100).toFixed(digits)}%`;
}

export function cls(...parts: (string | false | null | undefined)[]): string {
  return parts.filter(Boolean).join(' ');
}
